"use client";

import { useTranslations } from "next-intl";

const ICON_BASE = "/image/new-version/fabrication/laser-cutting/icons";

type CardConfig = {
	icon: string;
	bgClass: string;
	indexClass: string;
	translationPrefix: "card1" | "card2" | "card3";
	/** 浅底卡片：标题与正文用深色 */
	lightCard?: boolean;
};

const CARDS: CardConfig[] = [
	{
		icon: `${ICON_BASE}/1.svg`,
		bgClass: "bg-black",
		indexClass: "text-themePrimary400",
		translationPrefix: "card1",
	},
	{
		icon: `${ICON_BASE}/2.svg`,
		bgClass: "bg-[#107E03]",
		indexClass: "text-[#b8e986]",
		translationPrefix: "card2",
	},
	{
		icon: `${ICON_BASE}/3.svg`,
		bgClass: "bg-[#9EC687]",
		indexClass: "text-[#1a4d0a]",
		translationPrefix: "card3",
		lightCard: true,
	},
];

export default function LaserCuttingFeatureCards() {
	const t = useTranslations("laserCuttingFeatureCards");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16" aria-labelledby="laser-cutting-features-heading">
			<div className="container px-3 sm:px-4 md:px-6">
				<h2 id="laser-cutting-features-heading" className="sr-only">
					{t("sectionTitle")}
				</h2>
				<div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5 lg:gap-6">
					{CARDS.map((card) => {
						const light = card.lightCard;
						return (
							<article
								key={card.translationPrefix}
								className={`relative flex min-h-[280px] flex-col p-6 sm:min-h-[300px] sm:p-7  md:p-8 ${card.bgClass}`}
							>
								<div className="mb-6 flex items-start justify-between gap-4">
									<span className={`text-sm font-medium tracking-wide sm:text-base ${card.indexClass}`}>
										{t(`${card.translationPrefix}Index`)}
									</span>
									<div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-white p-2.5 shadow-sm sm:h-16 sm:w-16 sm:p-3">
										<img
											src={encodeURI(card.icon)}
											alt=""
											width={48}
											height={48}
											className="h-full w-full object-contain"
										/>
									</div>
								</div>
								<h3
									className={
										light
											? "mb-3 text-lg font-bold text-[#0f2908] sm:text-xl md:text-2xl"
											: "mb-3 text-lg font-bold text-white sm:text-xl md:text-2xl"
									}
								>
									{t(`${card.translationPrefix}Title`)}
								</h3>
								<p
									className={
										light
											? "text-sm leading-relaxed text-[#1a3d0f] md:text-base"
											: "text-sm leading-relaxed text-white/95 md:text-base"
									}
								>
									{t(`${card.translationPrefix}Desc`)}
								</p>
							</article>
						);
					})}
				</div>
			</div>
		</section>
	);
}
